import * as actions from "../actions/actions";
import * as actionTypes from "../actions/actionTypes";
import { connect } from "react-redux";
import { hashHistory } from "react-router";

import React from "react";

import IconList from "./nounproject-iconlist";
import PluginIconDetail from "./nounproject-plugin-icon-detail";
import PluginFooter from "./plugin-footer";
import Loading from "./loading";

let number_with_commas = require("./../legacy/helpers/number_with_commas")
    .default;

// import NounProjectPluginSignup from "./nounproject-plugin-login";

class NounProjectPlugin extends React.Component {
    static defaultProps = {
        maxIcons: 72
    };
    static propTypes = {
        maxIcons: React.PropTypes.number.isRequired
    };

    componentDidMount() {
        this.props.toggleIconDetail("show");
        this.executeSearch();
    }

    componentWillReceiveProps(nextProps, nextState) {
        let callTypes = [
            actionTypes.FETCH_ICONS,
            actionTypes.FETCH_PLUGIN_ICONS
        ];
        if (nextProps.apiResponse.actionType) {
            if (callTypes.includes(nextProps.apiResponse.actionType)) {
                this.setState({ processing: true });
            } else {
                this.setState({ processing: false });
            }
        }
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.searchQuery) {
            if (nextState.searchQuery !== nextProps.searchQuery) {
                this.setState({
                    searchQuery: nextProps.searchQuery
                });
                this.props.fetchIcons(nextProps.searchQuery, nextProps.page);
            }
            if (this.props.page !== nextProps.page) {
                this.props.fetchIcons(nextProps.searchQuery, nextProps.page);
            }
        }
    }

    constructor(props) {
        super(props);

        this.props.getIconMetaData();

        this.state = {
            processing: false,
            searchQuery: this.props.searchQuery
        };
    }

    executeSearch() {
        if (!this.props.searchQuery) {
            this.props.pluginIcons(this.props.page);
        } else {
            this.props.fetchIcons(this.props.searchQuery, this.props.page);
        }
    }

    render() {
        let view;

        if (this.state.processing) {
            return (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        height: "100%"
                    }}
                >
                    <Loading />
                    {this.renderUpsell()}
                    <PluginFooter showPagination={true} loading={true} />
                </div>
            );
        }

        if (!this.props.activeIcon) {
            view = this.renderIconView();
        } else {
            view = this.renderDetailIconView();
        }

        return view;
    }

    renderDetailIconView() {
        return (
            <div style={{ height: "100%" }}>
                <PluginIconDetail iconId={this.props.activeIcon.id} />
                <PluginFooter />
            </div>
        );
    }

    renderIconListView() {
        let iconList, iconListHeader;

        if (this.props.icons.length > 0) {
            if (!this.props.currentUser.has_premium_account) {
                iconListHeader = (
                    <div
                        className="display-flex banner grey padding-m weight-medium"
                        style={{
                            background: "#E8E8E8",
                            color: "#6D6D6D",
                            opacity: "0.95",
                            textAlign: "left",
                            fontSize: "14px"
                        }}
                    >
                        Locked Icons
                        <span
                            className="totalLockedIcons weight-light"
                            style={{
                                color: "#BABABA"
                            }}
                        >
                            {number_with_commas(this.props.totalIcons)} Icons
                        </span>
                    </div>
                );
            }

            iconList = (
                <IconList
                    maxIcons={this.props.maxIcons}
                    iconSize={"84"}
                    icons={this.props.icons}
                    dragAndDrop={false}
                />
            );
        }

        return (
            <span>
                {iconListHeader}
                {iconList}
            </span>
        );
    }

    renderIconFreemiumView() {
        let content, freemiumList, freemiumListHeader;

        if (
            !this.props.isFreemiumView &&
            !this.props.currentUser.has_premium_account
        ) {
            freemiumListHeader = (
                <div
                    className="display-flex banner grey padding-m weight-medium"
                    style={{
                        background: "#E8E8E8",
                        color: "#6D6D6D",
                        opacity: "0.95",
                        textAlign: "left",
                        fontSize: "14px"
                    }}
                >
                    Starter Pack
                </div>
            );
        }

        if (
            this.props.isFreemiumView ||
            !this.props.currentUser.has_premium_account
        ) {
            freemiumList = (
                <IconList
                    maxIcons={this.props.maxIcons}
                    iconSize={"84"}
                    icons={this.props.freemiumIcons}
                    dragAndDrop={false}
                />
            );
        }

        if (this.props.freemiumIcons.length > 0) {
            content = (
                <span>
                    {freemiumListHeader}
                    {freemiumList}
                </span>
            );
        }

        return content;
    }

    renderIconView() {
        let iconListView = this.renderIconListView(),
            freemiumListView = this.renderIconFreemiumView(),
            pagination = <PluginFooter showPagination={true} />,
            upsell = this.renderUpsell(),
            pluginPadding = upsell ? "100px" : "50px";

        if (this.props.totalIcons !== undefined) {
            if (this.props.totalIcons > 0) {
                return (
                    <div
                        className="plugin-container"
                        style={{
                            paddingTop: "85px",
                            paddingBottom: pluginPadding
                        }}
                    >
                        {freemiumListView}
                        {iconListView}
                        {upsell}
                        {pagination}
                    </div>
                );
            } else {
                return (
                    <article
                        className="margin-b-xxl"
                        style={{ textAlign: "center", marginTop: "80px" }}
                    >
                        <img
                            src="https://static.thenounproject.com/img/404_binoculars.4d1be94fcde6.svg"
                            width="300"
                            height="300"
                            alt="Icon of person holding binoculars"
                        />
                        <h1
                            className="font-large margin-b-xl"
                            style={{ maxWidth: "400px", margin: "auto" }}
                        >{`Bummer! Looks like we don't have an icon for "${
                            this.props.searchQuery
                        }"`}</h1>
                        <em>Try these tips to expand your search:</em>
                        <ul>
                            <li
                                style={{ textAlign: "cetner", margin: "3px 0" }}
                            >
                                Use fewer keywords
                            </li>
                            <li
                                style={{ textAlign: "cetner", margin: "3px 0" }}
                            >
                                Check for spelling errors or typos
                            </li>
                        </ul>
                        <PluginFooter />
                    </article>
                );
            }
        } else {
            return null;
        }
    }

    renderUpsell() {
        let upsell = (
            <div
                style={{
                    alignItems: "center",
                    position: "fixed",
                    width: "100%",
                    bottom: "50px",
                    height: "50px",
                    background: "#000000",
                    color: "#FFFFFF",
                    zIndex: "11"
                }}
            >
                <div
                    style={{
                        maxWidth: "600px",
                        width: "100%",
                        padding: "0 8px",
                        margin: "auto",
                        justifyContent: "space-between",
                        display: "flex"
                    }}
                >
                    <div
                        className="display-flex"
                        style={{
                            alignItems: "center"
                        }}
                    >
                        <div
                            className="ui_pro-accounts"
                            style={{
                                fontSize: "24px",
                                padding: "8px"
                            }}
                        />
                        <div>
                            <div className="weight-medium">
                                NounPro unlocks all icons
                            </div>
                            <div className="weight-light">
                                only $39.99 billed yearly
                            </div>
                        </div>
                    </div>
                    <a
                        className="display-flex"
                        style={{ alignItems: "center" }}
                        href=""
                        onClick={this.showUpgrade.bind(this)}
                    >
                        <span
                            className="text-link weight-medium"
                            style={{
                                color: "#3EA9F5",
                                textDecoration: "underline",
                                fontSize: "12px"
                            }}
                        >
                            Get started
                        </span>
                    </a>
                </div>
            </div>
        );

        if (this.props.currentUser.has_premium_account) {
            upsell = null;
        }

        return upsell;
    }

    showBilling() {
        hashHistory.push("billing");
    }

    showSignup() {
        hashHistory.push(`signup`);
    }

    showUpgrade(e) {
        e.preventDefault();

        if (this.props.currentUser.is_anonymous) {
            this.showSignup();
        } else {
            this.showBilling();
        }
    }
}

function mapStateToProps(state, ownProps) {
    let activeIcon,
        apiResponse = state.apiResponse,
        freemiumIcons = [],
        isFreemiumView = false,
        page = state.plugin.page,
        icons = [],
        host = state.plugin.host,
        searchQuery = state.search.query,
        totalIcons,
        currentUser;

    if (state.icons.keys) {
        state.icons.keys.forEach(iconId => {
            let icon = state.icons[iconId];

            if (icon.freemium) {
                freemiumIcons.push(icon);
            } else {
                icons.push(icon);
            }
        });
    }

    if (!searchQuery && !icons.length) {
        isFreemiumView = true;
    }
    if (state.icons.active_icon) {
        activeIcon = state.icons.active_icon;
    }

    totalIcons = state.icons.search_total;

    currentUser = state.user;

    return {
        page,
        host,
        icons,
        apiResponse,
        searchQuery,
        totalIcons,
        activeIcon,
        isFreemiumView,
        freemiumIcons,
        currentUser
    };
}

module.exports = connect(
    mapStateToProps,
    {
        fetchIcons: actions.fetchIcons,
        setPage: actions.setPage,
        showLogin: actions.showLogin,
        pluginIcons: actions.pluginIcons,
        toggleIconDetail: actions.toggleIconDetail,
        getIconMetaData: actions.getIconMetaData
    }
)(NounProjectPlugin);
